import React, { useEffect, useRef, useState } from 'react';
import { hocSinhApi } from '../../api/hocsinh_api';
import PhuHuynhChildItem from '../phu-huynh-child-item';
import PlaceHolder from '../place-holder';
import styles from "./PhuHuynhChildList.module.css";
import { useSelector } from 'react-redux';
const PhuHuynhChildList = ({ id, hocSinhSelectedId, onSelected, countToRerender, mode, onDeleted }) => {
    const [hocSinhs, setHocSinhs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const componentDidMount = useRef(false)
    const { dm_coso_id } = useSelector(x => x.coSo);
    useEffect(() => {
        componentDidMount.current = true;
        handleReloadHocSinh();
        return () => {
            componentDidMount.current = false;
        }
    }, [id, countToRerender])
    const handleReloadHocSinh = async () => {
        setIsLoading(true);
        const res = await hocSinhApi.SelectByParent(id);
        if (componentDidMount.current) {
            setIsLoading(false);
            if (res.is_success) {
                res.data = res.data.filter(x => x.dm_coso_id == dm_coso_id);
                setHocSinhs(res.data)
            }
        }

    }

    return (
        <div>
            {mode == "column" && <>
                {hocSinhs.length > 0 && <p style={{ marginTop: 10 }} className={styles.caption}>Học sinh</p>}
                <div className={styles.list_horizontal}>
                    {hocSinhs.map((hocSinh, idx) => {
                        return (
                            <div className={styles.list_horizontal_item}>
                                <PhuHuynhChildItem key={idx} hocSinh={hocSinh}
                                    isSelected={hocSinhSelectedId == hocSinh.id}
                                    onSelected={() => {
                                        onSelected(hocSinh.id)
                                    }}
                                    onDeleted={() => {
                                        onDeleted(id, hocSinh.id)
                                    }}
                                />
                            </div>
                        );
                    })}
                </div>
            </>}
            {(!mode || mode != "column") && <>
                {hocSinhs.length > 0 && <p className={styles.caption}>Học sinh</p>}
                {isLoading && <PlaceHolder />}
                {!isLoading && <>
                    {hocSinhs.map((hocSinh, idx) => {
                        return (
                            <PhuHuynhChildItem key={idx} hocSinh={hocSinh}
                                isSelected={hocSinhSelectedId == hocSinh.id}
                                onSelected={() => {
                                    onSelected(hocSinh.id)
                                }}
                                onDeleted={() => {
                                    onDeleted(id, hocSinh.id)
                                }}
                            />
                        );
                    })}
                </>
                }
            </>}
        </div>
    );
};

export default PhuHuynhChildList;